import React from 'react';

import cn from 'classnames';

import { isClientAttachment } from '@entities/attachment/lib';
import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { getNameExtension } from '@shared/helpers';

import cls from './DnDImageList.module.css';

interface DnDImageListProps {
    classes?: string;
    file?: TAttachmentOnClient | TAttachmentDTOCamelCased;
    onClickInputRef?: () => void;
}

export const DnDImageList = ({ classes, file, onClickInputRef }: DnDImageListProps) => {
    const getAttachmentInfo = (file: TAttachmentOnClient | TAttachmentDTOCamelCased) => {
        const isFromClient = isClientAttachment(file);
        const isFileLoading = isFromClient ? file?.isLoading : false;
        const isImg = isFromClient
            ? file?.file?.type.startsWith('image/')
            : file?.mimeType?.startsWith('image/');
        const fileImgUrl = isFromClient ? URL.createObjectURL(file?.file) : file?.originalUrl;
        const fileName = isFromClient ? file?.file?.name : file?.name;
        const { extension: fileExtension, name } = getNameExtension(fileName);

        return {
            isFileLoading,
            isImg,
            fileImgUrl,
            fileName: name,
            fileExtension,
        };
    };

    const { fileImgUrl, fileName } = getAttachmentInfo(file);

    return (
        <div onClick={onClickInputRef} className={cn(cls.DnDImageList, [classes])}>
            <img src={fileImgUrl} alt={fileName} />
        </div>
    );
};
